import * as React from 'react';
import { useState } from 'react';
import { PageTitle } from '@uifabric/portal-ux/lib/Page';
import { useTheme } from '@fluentui/react';
import { QosProvider } from '@iamexperiences/ecos-telemetry';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';

import { ConsentPageContent } from './ConsentPageContent';
import { classNames } from '../shared/TermsOfUse.styles';
import { useGetTenantDisplayNameUnauthenticated } from '../hooks/useGetTenantDisplayName';
import { useGetPreferredUsername } from '../hooks/useGetPreferredUsername';
import { Page } from '../../Application/Page';

export const Consent: React.FC = () => {
  const theme = useTheme();
  const [t] = useLocalization('TermsOfUse');

  const getTenantDisplayNameQuery = useGetTenantDisplayNameUnauthenticated();
  const tenantDisplayName = getTenantDisplayNameQuery.data || '';

  const preferredUsername =  useGetPreferredUsername();

  const [isTermsOfUseDeclined, setIsTermsOfUseDeclined] = useState(false);

  let title: string;
  let subtitle: string;
  if (isTermsOfUseDeclined) {
    title = t('accessRestrictedTitle');
    subtitle = t('accessRestrictedSubtitle', { orgName: tenantDisplayName });
  } else {
    title = tenantDisplayName ? t('orgTermsOfUse', { orgName: tenantDisplayName }) : t('termsOfUse');
    subtitle = t('messageMustReadTermsOfUse', { orgName: tenantDisplayName });
  }

  return (
    <QosProvider name="TermsOfUseConsent">
      <Page
        automationId="TermsOfUse"
        styles={{
          root: { fontSize: theme.fonts.medium.fontSize },
        }}
      >
      <div className={classNames.subtitleClass}>
        {preferredUsername}
      </div>
        {getTenantDisplayNameQuery.isSuccess && (
          <>
            <PageTitle
              styles={() => ({
                root: {
                  fontSize: theme.fonts.xxLarge.fontSize,
                },
              })}
            >
              {title}
            </PageTitle>
            <div id="consentSubHeading" className={classNames.subtitleClass}>
              {subtitle}
            </div>
            {
              // Show consent view if the user hasn't declined yet
              !isTermsOfUseDeclined && (
                <ConsentPageContent
                  onTermsOfUseDecline={() => setIsTermsOfUseDeclined(true)}
                  tenantDisplayName={tenantDisplayName}
                />
              )
            }
          </>
        )}
      </Page>
    </QosProvider>
  );
};
